<!--
 * @Date: 2020-06-28 10:46:51
 * @LastEditors: 曹捷
 * @LastEditTime: 2022-07-01 15:41:33
 * @Description: 客户登录
--> 
<template>
  <div class="client-login-container login-container" :class="ENV">
    <div class="login-frame-parents-content">
      <div class="login-frame-content flex-l-r">
        <div class="left">
          <obitEnv>
            <template #zs>
              <img src="@/assets/zs/images/login1.png" class="m-l-20 w100" alt="">
            </template>
            <template #xj>
              <img src="@/assets/images/login/xj1.png" class="m-l-20 " alt="" style="width:130px;">
              <img src="@/assets/images/login/xj2.png" class="m-l-20 " alt="" style="width:160px;">
            </template>
            <img src="@/assets/images/login/yhlLogo.svg" alt="">
            <img src="@/assets/images/login/yhlTitle.svg" alt="">
            <img src="@/assets/images/login/yhlDesc.svg" alt="">
          </obitEnv>
        </div>
        <div class="right">
          <div class="t-c login-title">
            用户登录
          </div>
          <div class="line"></div>
          <a-form :model="formData" layout="vertical" :rules="loginRules" class="login-form" ref="formRef">
            <a-form-item label="账号" name="username">
              <div class="flex-l-r">
                <a-input class="login-input" :spellcheck="false" autocomplete="off" name="username"
                  placeholder="请输入您的账号" ref="username" tabindex="1" type="text" v-model:value="formData.username">
                </a-input>
              </div>
            </a-form-item>
            <a-form-item label="密码" name="password">
              <div class="flex-l-r">
                <a-input-password class="login-input" :key="passwordType" :type="passwordType"
                  @keyup.enter.native="handleLogin" autocomplete="on" name="password" placeholder="请输入您的密码"
                  ref="password" tabindex="2" v-model:value="formData.password">
                </a-input-password>
              </div>
            </a-form-item>
            <a-form-item label="验证码" name="code">
              <a-input class="login-input  " autocomplete="off" @keyup.enter.native="handleLogin" placeholder="验证码"
                v-model:value="formData.code">
                <template #suffix>
                  <img class="login-img" :src="loginCode" @click="initLogin" />
                </template>
              </a-input>
            </a-form-item>
            <div class="flex-l-r m-b-15">
              <a-checkbox v-model:checked="checked">记住账号</a-checkbox>
              <!-- <a href="" class="forget">忘记密码</a> -->
            </div>
            <a-button v-loading="loading" class="login-btn" type="primary" size="large" block
              @click.native.prevent="handleLogin">登 录
            </a-button>
            <!-- <div class="register m-t-10">
              <a href="">新用户注册 ></a>
            </div> -->
          </a-form>
        </div>
      </div>
      <div class="footer">
        <div v-if="ENV==='XJ'">吐鲁番烈炬网络科技有限公司 版权所有 Copyright 2018-2021</div>
        <div v-else>湖南易比特大数据有限公司 版权所有 Copyright 2018-2021</div>
        <a href="https://beian.miit.gov.cn/" target="_blank">湘ICP备19020062号-2</a>
        <div style="width:300px;margin:0 auto;">
          <a target="_blank" href=" " style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">
            <img src="./ba.png" style="float:left;" />
            <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">湘公网安备
              43019002001705号</p>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { toRefs, reactive } from 'vue'
import loginHook from 'obit-wui/hook/login/v2.js'
export default {
  name: 'Login',
  setup (props, context) {
    let login = loginHook({
      checked: true
    })
    let _data = reactive({
      ENV: sessionStorage.getItem('SENV')
    })
    return {
      ...toRefs(login._data),
      ...login._method,
      ...login._computed,
      ...toRefs(_data)
    }
  },
}
</script>

<style lang="less" scoped>
.client-login-container {
  background: #f0f2f5;
  background-image: url('./../../assets/images/login/bg1.png');
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-y: auto;
  background-size: 100% 100%;
  background-position: center 0;
  background-repeat: no-repeat;
  min-height: 900px;
  &.ZS {
    background-image: url('./../../assets/zs/images/login2.png');
  }
  &.XJ {
    background-image: url('./../../assets/images/login/xj0.png');
  }
  .login-bg {
    position: absolute;
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    z-index: 0;
    background-size: 100% 100%;
  }
  .footer {
    color: #d9d9d9;
    font-size: 12px;
    padding-bottom: 12px;
    text-align: center;
    line-height: 24px;
    a {
      color: #d9d9d9;
    }
  }
  .login-img {
    width: 90px;
    height: 100%;
  }
  .login-frame-parents-content {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .login-form {
      margin-top: 15px;
      .svg-container {
        color: #1890ff;
        font-size: 18px;
      }
      .ant-form-item {
        height: 83px;
        margin-bottom: 4px !important;
        flex-flow: column;
        .login-input {
          height: 37px;
          border: 1px solid #d9d9d9;
          background: #1a2535;
          input {
            background: transparent;
          }
        }
      }
      .ant-form-item-label {
        padding: 0;
        > label {
          font-size: 12px;
        }
      }
      .ant-form-item-with-help {
        margin-bottom: 24px;
      }
      .forget {
        color: #f8f8f8;
        text-decoration-line: underline;
      }
    }
    .register {
      height: 38px;
      line-height: 38px;
      text-align: center;
      a {
        color: #f8f8f8;
      }
    }
    .login-frame-content {
      position: relative;
      top: 21%;
      width: 825px;
      height: 470px;
      margin: 0 auto;

      border-radius: 10px;
      border: 1px solid #606c91;

      //  background: linear-gradient(
      //   317.15deg,
      //   rgba(228, 185, 255, 0.3) 1.13%,
      //   rgba(255, 255, 255, 0) 46.2%
      // );
      // backdrop-filter: blur(10px);
      // background-size: 100% 100%;
      // backdrop-filter: blur(10px);
      z-index: 1;
      .left {
        display: flex;
        flex-direction: column;
        flex: 1;
        min-width: 0;
        align-items: center;
        justify-content: space-around;
        padding: 100px 0;
      }
      .right {
        width: 436px;
        padding: 30px 60px 34px 60px;
      }
      .logo {
        width: 140px;
        height: 43px;
        display: block;
        margin: 0 auto;
        margin-top: 25px;
        margin-bottom: 15px;
      }
      .login-title {
        font-family: PingFang SC;
        font-style: normal;
        font-weight: 500;
        font-size: 18px;
        color: #f8f8f8;
        line-height: 16px;
      }
      .line {
        border-top: 1px solid #c4c4c4;
        margin-top: 15px;
      }
    }
    // .login-frame-content::after {
    //   content: ' ';
    //   position: absolute;
    //   top: -3px;
    //   bottom: -3px;
    //   left: -3px;
    //   right: -3px;
    //   background: linear-gradient(
    //     130.15deg,
    //     #f8ecff -9.45%,
    //     rgba(218, 157, 255, 0.554047) 46.9%,
    //     rgba(255, 255, 255, 0) 116.91%
    //   );
    //   border-radius: 10px;
    //   content: '';
    //   z-index: -999;
    // }
    .login-frame-content::before {
      content: ' ';
      position: absolute;
      top: 0px;
      bottom: 0px;
      left: 0px;
      right: 0px;
      border-radius: 10px;
      z-index: -1;
      background: linear-gradient(
        317.15deg,
        rgba(228, 185, 255, 0.3) 1.13%,
        rgba(255, 255, 255, 0) 46.2%
      );
      backdrop-filter: blur(10px);
      background-size: 100% 100%;
      backdrop-filter: blur(10px);
    }
  }
}
</style>
